import Contracts from '../components/contracts/Contracts';
import ContractCreate from '../components/contracts/ContractCreate';
import ContractEdit from '../components/contracts/ContractEdit';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/contracts',
  component: Template,
  children: [
    {
      path: '',
      name: 'Contracts',
      component: Contracts,
      meta: {
        title: 'Contracts - Mod24',
      },
    },
    {
      path: 'create',
      name: 'ContractCreate',
      component: ContractCreate,
      meta: {
        title: 'Create contract - Mod24',
      },
    },
    {
      path: 'edit/:id',
      name: 'ContractEdit',
      component: ContractEdit,
      meta: {
        title: 'Edit contract - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/contractsRoutes.js